var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconShowEyeFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1581_104)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.89811 5.66602C7.37973 5.66602 6.88259 5.87673 6.51604 6.2518C6.14949 6.62687 5.94357 7.13558 5.94357 7.66602C5.94357 8.19645 6.14949 8.70516 6.51604 9.08023C6.88259 9.4553 7.37973 9.66602 7.89811 9.66602C8.41649 9.66602 8.91364 9.4553 9.28018 9.08023C9.64673 8.70516 9.85266 8.19645 9.85266 7.66602C9.85266 7.13558 9.64673 6.62687 9.28018 6.2518C8.91364 5.87673 8.41649 5.66602 7.89811 5.66602ZM7.89811 10.9993C7.03415 10.9993 6.20557 10.6482 5.59466 10.023C4.98374 9.39792 4.64054 8.55007 4.64054 7.66602C4.64054 6.78196 4.98374 5.93411 5.59466 5.30899C6.20557 4.68387 7.03415 4.33268 7.89811 4.33268C8.76207 4.33268 9.59065 4.68387 10.2016 5.30899C10.8125 5.93411 11.1557 6.78196 11.1557 7.66602C11.1557 8.55007 10.8125 9.39792 10.2016 10.023C9.59065 10.6482 8.76207 10.9993 7.89811 10.9993ZM7.89811 2.66602C4.64054 2.66602 1.85857 4.73935 0.731445 7.66602C1.85857 10.5927 4.64054 12.666 7.89811 12.666C11.1557 12.666 13.9377 10.5927 15.0648 7.66602C13.9377 4.73935 11.1557 2.66602 7.89811 2.66602Z",
    fill: "#B3B7C1"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1581_104"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0.0649414)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShowEyeFill);
export default __webpack_public_path__ + "static/media/Icon-show-eye-fill.69bd44ae47b874e074464f7f7a3ce619.svg";
export { ForwardRef as ReactComponent };